import { render, staticRenderFns } from "./NickName.vue?vue&type=template&id=4d3aafe8&scoped=true&lang=html"
import script from "./NickName.vue?vue&type=script&lang=js"
export * from "./NickName.vue?vue&type=script&lang=js"
import style0 from "./NickName.vue?vue&type=style&index=0&id=4d3aafe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3aafe8",
  null
  
)

export default component.exports